import z from "zod";

import { locale } from "@/common/locale";
import { validateEmptyDate, validateDateNotInFuture } from "@/common/model";

export const tradingFiltersSchema = z.object({
  createdAt: z
    .string()
    .trim()
    .refine((value) => validateEmptyDate(value), {
      message: locale.dateFormat,
    })
    .refine(validateDateNotInFuture, {
      message: locale.dateNotInFuture,
    })
    .optional(),
});

export type TradingFiltersSchema = z.infer<typeof tradingFiltersSchema>;
